export default import.meta.ROLLUP_FILE_URL_BIQ95U7o;